<template>
  <div>
    <v-dialog v-model="photoDialog">
      <v-card>
        <img
          :src="photoDialogUrl || null" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="boarderDateError" persistent max-width="650">
      <v-alert
        elevation="4"
        type="info"
        border="bottom"
        colored-border
        class="mb-0"
        prominent
      >
        <v-container class="d-flex py-7">
          <div class="font-readex font-weight-bold text-black"> Na zadané datum mají již objednáno následující strávníci: <br>
            {{ boardersWithDateError.map(boarder => `${boarder.firstName} ${boarder.lastName}`).join(', ') }}</div>
          <div class="d-flex justify-end" >
            <v-btn class="btn btn-green-gradient" dark @click="dismissBoarderDateError">Beru na vědomí</v-btn>
          </div>
        </v-container>
      </v-alert>
    </v-dialog>

    <v-row justify="center">
      <v-col cols="12" md="3">
        <v-card class=" rounded-lg" elevation="2">
          <v-card-title class="heading font-readex font-weight-bold" style="text-align: center">Vyberte datum</v-card-title>
          <template>
            <v-date-picker
              v-model="selectedDate"
              class="mt-4 rounded-0"
              :min="minPickerDate"
              :max="maxPickerDate"
              full-width
              :allowed-dates="allowedDates"
              first-day-of-week="1"
              color="darkGreen"
              @change="initializeDietDay"
            ></v-date-picker>
          </template>
        </v-card>
      </v-col>
      <v-col cols="12" md="9">
        <div v-if="dayEmpty && !loading && this.selectedDate !== null" class="font-weight-bold font-readex">
          Žádné položky k zobrazení
        </div>
        <div class="font-weight-bold font-readex" v-if="this.selectedDate === null && !loading">Zvolte datum</div>
        <v-data-table
          v-if="loading"
          mobile-breakpoint="50"
          :headers="headers"
          show-expand
          class="elevation-0 order-table stripedDT lightYellow rounded-lg"
          hide-default-footer
          disable-sort
          dense
          :loading="loading"
          loading-text="Probíhá načítání dat..."
        ></v-data-table>
        <div
          v-for="(time, index) in availableFood"
          :key="index">
          <v-data-table
            v-if="time.length"
            mobile-breakpoint="50"
            :headers="headers"
            :items="time"
            :expanded="expanded"
            item-key="name"
            :items-per-page=-1
            class="stripedDT lightYellow rounded-lg"
            show-expand
            hide-default-footer
            disable-sort
            calculate-widths
          >
            <template v-slot:top>
              <v-toolbar flat dense>
                <v-toolbar-title class="text-darkGreen font-weight-bold text-uppercase font-readex">{{timeTypes.length ? timeTypes[index].name : ''}}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:item.name="{ item }">
              <span :class="{ 'special-offer': item.specialOffer }">{{item.name}}</span>
            </template>
            <template v-slot:item.photo="{ item }">
              <v-icon
                v-if="item.imageUrl"
                small
                class="mr-2"
                @click="showPhoto(item.imageUrl)"
              >
                mdi-camera
              </v-icon>
            </template>
            <template v-slot:item.nameStr="{ item }">
              <div class="text-darkGreen font-weight-bold" style="font-size: 1.1em">{{item.name}}</div>
              <span style="font-size: 0.8em;">{{item.foodTypesStr}}</span>
            </template>
            <template v-slot:item.priceStr="{ item }">
              <span class="text-darkGreen font-weight-bold">{{item.price + ' Kč'}}</span>
            </template>
            <template v-slot:item.alergensStr="{ item }">
              <span style="font-size: 0.8em;">{{item.alergensStr}}</span>
            </template>
            <template v-slot:item.quantity="{ item }" v-if="cart.order" >
              <div class="d-flex">
                <v-icon slot="prepend" class="mr-2" color="red" @click="minusQuantity(item)">fa-circle-minus</v-icon>
                <v-text-field
                  v-if="item.editable"
                  v-model="item.quantity"
                  class="order-quantity"
                  type="number"
                  min="0"
                  dense
                  @change="addToCart"
                  hide-details
                  outlined
                  style="background-color: white; min-width: 60px"
                  rounded
                >
                </v-text-field>
                <v-icon slot="append" color="green" @click="plusQuantity(item)" class="ml-2">fa-circle-plus</v-icon>
              </div>
            </template>
            <template v-slot:item.quantity="{ item }" v-else>
              <v-checkbox
                v-if="item.editable"
                :label="item.selected ? 'Objednáno' : 'Objednat'"
                v-model="item.selected"
                :disabled="/* disabledDayTimeInputs[index] */false"
                @change="selectItemBoarders(item)"
              ></v-checkbox>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td
                :colspan="headers.length"
                v-if="item.type === 'App\\Menu'"
              >
                <div
                  v-for="(menuItem, index) in item.drinks.concat(item.foods)" :key="index"
                >{{menuItem.name}}</div>
              </td>
              <td
                :colspan="headers.length"
                v-else
              >{{item.name}}</td>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
    <!--    <div>{{selectedDate ? getLocalizedDate(selectedDate) : ''}} {{selectedDate? getLocalizedWeekDay(selectedDate) : ''}}</div>-->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'NewStep2',
  data () {
    return {
      boarderDateError: false,
      boardersWithDateError: [],
      loadingDialog: false,
      boardersOrderDates: {},
      selectedDate: null,
      dateDialog: false,
      availableFood: [[], [], [], [], [], []],
      headers: [
        { text: '', value: 'photo', sortable: false, width: 1 },
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'nameStr',
          width: 150
        },
        { text: 'Alergeny', value: 'alergensStr', width: 75 },
        { text: 'Kalorie', value: 'calories', width: 75 },
        { text: 'Cena', value: 'priceStr', width: 100 },
        { text: '', value: 'quantity', width: 150 },
        { text: '', value: 'data-table-expand' }
      ],
      expanded: [],
      photoDialog: false,
      photoDialogUrl: null,
      loading: false,
      dietDayRequestId: 0
    }
  },
  methods: {
    dismissBoarderDateError () {
      this.boarderDateError = false
    },
    initializeDietDay () {
      this.loading = true
      this.boardersWithDateError = []
      this.availableFood = [[], [], [], [], [], []]

      if (this.selectedDate === null) {
        const fullDate = new Date()
        const datum = fullDate.getDate()
        const year = fullDate.getFullYear()
        let month = fullDate.getUTCMonth()
        month = month + 1
        if (month < 10) month = '0' + month.toString()
        this.selectedDate = year + '-' + month + '-' + datum
      }

      const loadDay = () => {
        for (const boarderId in this.boardersOrderDates) {
          if (this.boardersOrderDates[boarderId].includes(this.selectedDate)) {
            const boarder = this.cart.boarders.find(boarder => boarder.id === +boarderId)
            this.boardersWithDateError.push(boarder)
          }
        }
        if (this.boardersWithDateError.length) {
          this.boarderDateError = true
          this.loading = false
          return
        }

        const dietID = this.cart.diet.id
        const date = this.selectedDate
        this.dateDialog = false
        const requestId = ++this.dietDayRequestId

        this.$http.get(`/diets/${dietID}/days/date/${date}`)
          .then(response => {
            // Ignore stale responses when the user changes date quickly
            if (requestId !== this.dietDayRequestId) {
              return
            }

            let dietDayItems = []
            const res = this.keysToCamelCase(response.data)
            if (Object.keys(res).length) {
              dietDayItems = res.dietDayItems || []
            }
            const items = dietDayItems.map(item => {
              item = { ...item, ...(item.eatable || {}) }
              item.alergensStr = (item.alergens || [])
                .map(alergen => alergen.name)
                .join(', ')
              item.foodTypesStr = (item.foodTypes || [])
                .map(foodTypes => foodTypes.name)
                .join(', ')
              item.drinks = item.drinks || []
              item.foods = item.foods || []
              item.selected = false
              item.quantity = 0
              return item
            })
            this.availableFood = [[], [], [], [], [], []].map((time, index) => {
              return items.filter(item => item.timeId === index + 1)
            })

            // only editable
            this.availableFood = this.availableFood.map(time => time.filter(f => f.editable))

            // map to shopping cart
            if (this.cart.items[date]) {
              this.availableFood = this.availableFood.map((time, index) => {
                if (!this.cart.items[date][index] || !this.cart.items[date][index].length) {
                  return time
                }
                return time.map(food => {
                  const shoppingCartFood = this.cart.items[date][index]
                    .find(f => f.id === food.id && f.type === food.type)
                  if (shoppingCartFood) {
                    food.selected = true
                    food.quantity = shoppingCartFood.quantity
                  }
                  return food
                })
              })
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            if (requestId === this.dietDayRequestId) {
              this.loading = false
            }
          })
      }

      if (!this.orderObject.id && this.cart.boarders.length) {
        this.$http.post('/showOrderedDates', {
          boarder_ids: this.cart.boarders.map(boarder => boarder.id)
        })
          .then(res => {
            const response = this.keysToCamelCase(res.data)
            this.boardersOrderDates = {}
            Object.keys(response).forEach(boarderId => {
              this.boardersOrderDates[boarderId + ''] = response[boarderId]
            })
          })
          .catch(err => console.log(err))
          .finally(() => {
            loadDay()
          })
      } else {
        loadDay()
      }
    },
    checkBoarders () {
      if (!this.orderObject.id) {
        this.$http.post('/showOrderedDates', {
          boarder_ids: this.cart.boarders.map(boarder => boarder.id)
        })
          .then(res => {
            const response = this.keysToCamelCase(res.data)
            this.boardersOrderDates = {}
            Object.keys(response).forEach(boarderId => {
              this.boardersOrderDates[boarderId + ''] = response[boarderId]
            })
            this.dateDialog = true
            this.loading = false
          })
          .catch(err => console.log(err))
      }
      for (const boarderId in this.boardersOrderDates) {
        if (this.boardersOrderDates[boarderId].includes(this.selectedDate)) {
          const boarder = this.cart.boarders.find(boarder => boarder.id === +boarderId)
          this.boardersWithDateError.push(boarder)
        }
      }
      if (this.boardersWithDateError.length) {
        this.boarderDateError = true
        // return
      }
    },
    getLocalizedDate (dateStr) {
      const date = new Date(dateStr)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    getLocalizedWeekDay (dateStr) {
      const date = new Date(dateStr)
      const localeDayStr = date.toLocaleDateString('cs-cz', { weekday: 'long' })
      return localeDayStr[0].toUpperCase() + localeDayStr.slice(1)
    },
    cancelDate () {
      this.dateDialog = false
      this.goToStep(1)
      /* if (Object.keys(this.cart.items).length) { // TODO: updating orders that should not be edited
        this.goToStep(3)
      } else {
        this.goToStep(1)
      } */
    },
    showPhoto (url) {
      this.photoDialog = true
      const base = axios.defaults.baseURL.split('/')
      this.photoDialogUrl = `${base.slice(0, 3).join('/')}${url}`
    },
    plusQuantity (item) {
      ++item.quantity
      this.addToCart()
      this.updateShoppingCartStorage()
    },
    minusQuantity (item) {
      if (item.quantity > 0) {
        --item.quantity
      }
      this.addToCart()
      this.updateShoppingCartStorage()
    },
    selectItemBoarders (item) {
      this.availableFood[item.timeId - 1] = this.availableFood[item.timeId - 1]
        .map(food => {
          if (food !== item) {
            food.selected = false
            food.quantity = 0
          }
          this.addToCart()
          return food
        })
      if (item.selected) {
        item.quantity = 1
        // this.cart.items[this.selectedDate][item.timeId - 1].push(item)
        this.addToCart()
      } else {
        item.quantity = 0
        this.addToCart()
      }
    },
    continueShopping () {
      this.dateDialog = true
      this.expanded = []
      this.goToStep(2)
    },
    addToCart () {
      const allFood = this.availableFood.flat()

      // there is at at least 1 item with quantity > 0
      if (allFood.filter(food => food.quantity > 0).length) {
        this.cart.items[this.selectedDate] = []
        this.availableFood.forEach((time, index) => {
          this.cart.items[this.selectedDate][index] = time.filter(food => food.quantity > 0)
        })
      } else if (this.cart.items[this.selectedDate]) {
        const availableFoodEditable = !!this.availableFood
          .flat()
          .filter(f => f.editable)
          .length
        if (availableFoodEditable) {
          delete this.cart.items[this.selectedDate]
        }
      }
      this.sortShoppingCartKeys()
      this.updateShoppingCartStorage()
    },
    goToCart () {
      this.sortShoppingCartKeys()
      this.goToStep(3)
    },
    sortShoppingCartKeys () {
      const unordered = this.cart.items
      const ordered = {}
      Object.keys(unordered).sort().forEach(key => {
        ordered[key] = unordered[key]
      })
      this.cart.items = ordered
    },
    allowedDates (val) {
      if (this.orderObject.dates.length) {
        return this.orderObject.dates.indexOf(val) !== -1
      }
      return true
    },
    cancelOrder () {
      this.reset()
      this.$emit('order-canceled')
    },
    ...mapMutations({
      reset: 'ordering/reset',
      goToStep: 'ordering/goToOrderingStep',
      updateShoppingCartStorage: 'ordering/updateShoppingCartStorage'
    })
  },
  computed: {
    maxPickerDate () {
      return this.cart.diet ? this.cart.diet.dateTo : null
    },
    minPickerDate () {
      if (!this.cart.diet) {
        return null
      }

      const today = new Date()
      const dietFrom = new Date(this.cart.diet.dateFrom)
      return dietFrom.getTime() > today.getTime()
        ? this.cart.diet.dateFrom
        : today.toISOString().slice(0, 10)
    },
    dayEmpty () {
      return !(this.availableFood
        .flat()
        .length)
    },
    datePickerDisabled () {
      if (!this.selectedDate) {
        return true
      }
      return !(this.selectedDate >= this.minPickerDate && this.selectedDate <= this.maxPickerDate)
    },
    ...mapGetters({
      currentUser: 'user/currentUser',
      cart: 'ordering/shoppingCart',
      timeTypes: 'ordering/timeTypes',
      step: 'ordering/step',
      orderObject: 'ordering/cartOrder'
    }),
    // vuex bindings
    'cart.items': {
      get () {
        return this.$store.shoppingCart.state.cart.items
      },
      set (items) {
        this.$store.shoppingCart.state.cart.items = items
      }
    }
  },
  mounted () {
    this.checkBoarders()
  },
  watch: {
    step (newVal, oldVal) {
      if (oldVal === 1 && newVal === 3) {
        this.loadingDialog = true
        if (!this.orderObject.id) {
          this.$http.post('/showOrderedDates', {
            boarder_ids: this.cart.boarders.map(boarder => boarder.id)
          })
            .then(res => {
              const response = this.keysToCamelCase(res.data)
              this.boardersOrderDates = {}
              Object.keys(response).forEach(boarderId => {
                this.boardersOrderDates[boarderId + ''] = response[boarderId]
              })
              this.dateDialog = true
              this.loadingDialog = false
            })
            .catch(err => console.log(err))
        }

        this.dateDialog = true
        this.loadingDialog = false
        this.dateDialog = true
      }
    }
  }
}
</script>

<style scoped>

.special-offer {
  color: #ff7070;
}
/* Chrome, Safari, Edge, Opera */
>>>input::-webkit-outer-spin-button,
>>>input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
>>>input[type=number] {
  -moz-appearance: textfield;
}
</style>
